import { TickmillProductType } from '@/api/Clients/Types/TickmillProductDto'

import { NameDto } from '../../Common/Types'
import { Language } from './Language'

export interface NotificationDto {
  id: string
  name: string
  title: string
  text: string
  ctaUrl: string
  ctaText: string
  shortText: string
  startDateTime: string
  endDateTime: string
  isEnabled: boolean
  tickmillCompanies: NameDto[] | null
  notificationType: NameDto
  tickmillProducts: NotificationProductDto[]
  excludeTickmillProducts: NameDto<TickmillProductType>[]
  possibleTickmillProducts: NameDto<TickmillProductType>[]
  isSilent: boolean
  isPinned: boolean
  isClosable: boolean
  ctaUrlType: NameDto | null
  countryList: string[] | null
  notificationLanguages?: Language[] | null
  notificationAudiences: NotificationAudiencesDto[] | null
  images: NotificationImage[]
  isRead: boolean
  notificationPlatforms: NameDto[] | null
}

export interface NotificationProductDto extends NameDto<TickmillProductType> {
  statuses: NameDto[]
}

export interface ChangeNotificationProductDto {
  id: TickmillProductType
  statuses: NameDto[]
}

export interface NotificationImage {
  id: string
  imageUrl: string
  additionalImageUrl?: string
  isDefault: boolean
  languageId: string
}

export enum NotificationDtoKey {
  name = 'name',
  type = 'notificationType.name',
  startDateTime = 'startDateTime',
  endDateTime = 'endDateTime',
  enabled = 'isEnabled',
}

export interface ChangeNotificationDto {
  id?: string
  name: string
  title: string
  text: string
  shortText?: string
  ctaUrl: string | null
  baseUrlTypeId: number | null
  ctaText: string | null
  startDateTime: string
  endDateTime: string
  isEnabled: boolean
  notificationTypeId: number
  tickmillCompanyIds: number[]
  tickmillProducts: ChangeNotificationProductDto[]
  excludeTickmillProductIds: TickmillProductType[]
  possibleTickmillProductIds: TickmillProductType[]
  isSilent: boolean
  isPinned: boolean
  isClosable: boolean
  countryIds: string[] | null
  languageIds: string[] | null
  notificationAudienceTypes: NameDto[]
  platformIds: number[] | null
  images: NotificationImage[]
}

export interface UploadNotificationImageDto {
  languageId: string
  image: string // base64
  additionalImage?: string | null
  isDefault: boolean
}

export interface ReplaceNotificationImageDto {
  image: string // base64
  additionalImage?: string | null
  updateImage: boolean
  updateAdditionalImage: boolean
  isDefault: boolean
}

export interface NotificationAudiencesDto {
  id: string
  typeId: number
  typeName: string
  value?: string
  restrictions?: { id: number; name: string }[]
}

export const isPromotionalNotificationType = (type: NameDto | null) => !!(type && type.id == 3)
